<div *ngIf="saveSuccessfullyMsg" class="print-history-popup">
  <div class="print-history-popup-body">
    <h2 class="popup-title">{{ "appointments.gui.labels.Saved Successfully" | translate }}</h2>
    <button
      (click)="saveSuccessfullyMsg = false"
      class="print-history-popup-close"
      aria-label="close popup"
    ></button>
  </div>
</div>
<div class="wrapper">
  <div class="m-box">
    <h2>{{ "appointments.gui.labels.SMS Settings" | translate }}</h2>
    <form [formGroup]="smsForm" (ngSubmit)="onSubmit()">
      <div style="display: flex; flex-direction: column; gap: 1em; align-items: flex-start">
        <div>
          <label> {{ "appointments.gui.labels.Clinic Address" | translate }}: </label>&nbsp;
          <input style="width: 25em" class="t-field menstural-field" formControlName="Address" />
        </div>
        <div>
          <label> {{ "appointments.gui.labels.Clinic Phone Number" | translate }}: </label>&nbsp;
          <input style="width: 25em" class="t-field menstural-field" formControlName="phone" />
        </div>
        <div>
          <label> {{ "appointments.gui.labels.Link to Additional Instructions" | translate }}: </label
          >&nbsp;
          <input
            style="width: 25em"
            class="t-field menstural-field"
            formControlName="instructionsLink"
          />
        </div>
        <div>
          <label> {{ "appointments.gui.labels.Waze Link" | translate }}: </label>&nbsp;
          <input style="width: 25em" class="t-field menstural-field" formControlName="wazeLink" />
        </div>
        <div *ngIf="loginService.premissions && loginService.premissions.examInstructionsLink">
          <label> {{ "appointments.gui.labels.exam_instructions" | translate }}: </label>&nbsp;
          <input
            style="width: 25em"
            class="t-field menstural-field"
            formControlName="examInstructions"
          />
        </div>

        <div>
          <label> {{ "appointments.gui.labels.additionalText" | translate }}: </label>&nbsp;
          <input style="width: 25em" class="t-field menstural-field" formControlName="additionalText" />
        </div>
        <ng-container *ngIf="loginService.premissions && loginService.premissions.surveyLink">
          <div>
            <label> {{ "appointments.gui.labels.Survey Form Link" | translate }}: </label>&nbsp;
            <input
              style="width: 25em"
              class="t-field menstural-field"
              formControlName="surveyFormLink"
            />
          </div>
        </ng-container>
        <div>
          <label> {{ "appointments.gui.labels.SMS Preview" | translate }}: </label>&nbsp;

          <mat-tab-group animationDuration="0ms">
            <mat-tab label="{{ 'appointments.gui.labels.Appointment Created' | translate }}">
              <p *ngIf="!loginService.premissions?.ApptsByRoom" class="sms-preview">
                שלום <span class="placeholder">שם פרטי</span>&nbsp;
                <span class="placeholder">שם משפחה</span>,
                <br />
                נקבע לך תור ל <span class="placeholder">שם הרופא</span> ממרפאת
                <span class="placeholder">שם המרפאה</span> ב
                <span class="placeholder">תאריך התור</span> בשעה
                <span class="placeholder">שעת התור</span> ל <span class="placeholder">שם הבדיקה</span>
                <br />
                <span *ngIf="smsForm.get('Address').value">
                  כתובת המרפאה:
                  <span class="placeholder-filled">
                    {{ smsForm.get("Address")?.value || "(clinic_address)" }}
                  </span>
                  <br />
                </span>
                <span *ngIf="smsForm.get('phone').value">
                  טלפון המרפאה:
                  <span class="placeholder-filled">
                    {{ smsForm.get("phone")?.value || "(clinic_phone)" }}
                  </span>
                  <br />
                </span>
                <span *ngIf="smsForm.get('instructionsLink').value">
                  הוראות הגעה:
                  <span class="placeholder-filled">
                    {{ smsForm.get("instructionsLink")?.value }}
                  </span>
                  <br />
                </span>
                <span *ngIf="smsForm.get('wazeLink').value">
                  לניווט בוויז:
                  <span class="placeholder-filled">
                    {{ smsForm.get("wazeLink")?.value }}
                  </span>
                  <br />
                </span>
                <span *ngIf="smsForm.get('additionalText').value">
                  <span class="placeholder-filled">
                    {{ smsForm.get("additionalText")?.value }}
                  </span>
                  <br />
                </span>
              </p>
              <p *ngIf="loginService.premissions?.ApptsByRoom" class="sms-preview">
                שלום <span class="placeholder">שם פרטי</span>&nbsp;
                <span class="placeholder">שם משפחה</span>,
                <br />
                נקבע לך תור למרפאת <span class="placeholder">שם המרפאה</span> ב
                <span class="placeholder">תאריך התור</span> בשעה
                <span class="placeholder">שעת התור</span> ל <span class="placeholder">שם הבדיקה</span>
                <br />
                <span *ngIf="smsForm.get('Address').value">
                  כתובת המרפאה:
                  <span class="placeholder-filled">
                    {{ smsForm.get("Address")?.value || "(clinic_address)" }}
                  </span>
                  <br />
                </span>
                <span *ngIf="smsForm.get('phone').value">
                  טלפון המרפאה:
                  <span class="placeholder-filled">
                    {{ smsForm.get("phone")?.value || "(clinic_phone)" }}
                  </span>
                  <br />
                </span>
                <span *ngIf="smsForm.get('instructionsLink').value">
                  הוראות הגעה:
                  <span class="placeholder-filled">
                    {{ smsForm.get("instructionsLink")?.value }}
                  </span>
                  <br />
                </span>
                <span *ngIf="smsForm.get('wazeLink').value">
                  לניווט בוויז:
                  <span class="placeholder-filled">
                    {{ smsForm.get("wazeLink")?.value }}
                  </span>
                  <br />
                </span>
                <span *ngIf="smsForm.get('additionalText').value">
                  <span class="placeholder-filled">
                    {{ smsForm.get("additionalText")?.value }}
                  </span>
                  <br />
                </span>
              </p>
            </mat-tab>
            <mat-tab label="{{ 'appointments.gui.labels.Appointment Updated' | translate }}">
              <p *ngIf="!loginService.premissions?.ApptsByRoom" class="sms-preview">
                שלום <span class="placeholder">שם פרטי</span>&nbsp;
                <span class="placeholder">שם משפחה</span>,
                <br />
                עודכן התור ל <span class="placeholder">שם הרופא</span> ממרפאת
                <span class="placeholder">שם המרפאה</span> ל
                <span class="placeholder">תאריך התור</span> לשעה
                <span class="placeholder">שעת התור</span> ל <span class="placeholder">שם הבדיקה</span>
                <br />
              </p>
              <p *ngIf="loginService.premissions?.ApptsByRoom" class="sms-preview">
                שלום <span class="placeholder">שם פרטי</span>&nbsp;
                <span class="placeholder">שם משפחה</span>,
                <br />
                עודכן התור למרפאת <span class="placeholder">שם המרפאה</span>&nbsp; ל
                <span class="placeholder">תאריך התור</span> לשעה
                <span class="placeholder">שעת התור</span> ל <span class="placeholder">שם הבדיקה</span>
                <br />
              </p>
            </mat-tab>
            <mat-tab label="{{ 'appointments.gui.labels.Appointment Reminder' | translate }}">
              <p *ngIf="!loginService.premissions?.ApptsByRoom" class="sms-preview">
                שלום <span class="placeholder">שם פרטי</span>&nbsp;
                <span class="placeholder">שם משפחה</span>,
                <br />
                זוהי תזכורת לתור ל <span class="placeholder">שם הרופא</span> ממרפאת
                <span class="placeholder">שם המרפאה</span> ב
                <span class="placeholder">תאריך התור</span> בשעה
                <span class="placeholder">שעת התור</span> ל <span class="placeholder">שם הבדיקה</span>
                <br />
                לאישור הגעה או ביטול הגעה יש להיכנס לקישור.
                <br />
              </p>
              <p *ngIf="loginService.premissions?.ApptsByRoom" class="sms-preview">
                שלום <span class="placeholder">שם פרטי</span>&nbsp;
                <span class="placeholder">שם משפחה</span>,
                <br />
                זו היא תזכורת לתור למרפאת
                <span class="placeholder">שם המרפאה</span> ל
                <span class="placeholder">תאריך התור</span> בשעה
                <span class="placeholder">שעת התור</span> ל <span class="placeholder">שם הבדיקה</span>
                <br />
                לאישור הגעה או ביטול הגעה יש להיכנס לקישור.
                <br />
              </p>
            </mat-tab>
          </mat-tab-group>
        </div>
        <button
          class="orange-btn"
          [matTooltip]="'appointments.gui.tooltips.Save Changes' | translate"
          type="submit"
        >
          {{ "appointments.gui.buttons.Save" | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
